<template>
    <breadCrumbs title="Font Awesome Icons" main="Icons" title1="Font Awesome Icons" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12" v-for="(item, index) in menu" :key="index">
                <div class="card">
                    <div class="card-header pb-0">
                        <h3 class="m-b-0"><span v-if="item.name == 'Icons'">20</span> {{ item.name }}</h3>
                    </div>
                    <div class="card-body">
                        <div class="row icon-lists">

                            <div class="col-sm-6 col-md-6 col-lg-4" v-for="(index) in item.value" :key="index"
                                v-on:click="icon_bar(index)">
                                <i class="" :class="'fa fa-' + index"></i>{{ index }}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="icon-hover-bottom p-fixed fa-fa-icon-show-div" :class="{ 'opecity-0': !icon_bar_status }"
        :style="[icon_bar_status ? { 'display': 'block' } : { 'display': 'none' }]">
        <div class="container-fluid">
            <div class="row">
                <div class="icon-popup">
                    <div class="close-icon" v-on:click="close_icon_bar"><i class="icofont icofont-close"></i></div>
                    <div class="icon-first"><i class="fa-2x" :class="[select_icon.class]"></i></div>
                    <div class="icon-class">
                        <label class="icon-title">Class</label><span>icon-drupal</span>
                    </div>
                    <div class="icon-last icon-last">
                        <label class="icon-title">Markup</label>
                        <div class="form-inline">
                            <div class="form-group">
                                <input class="inp-val form-control m-r-10" type="text" ref="text" :value="select_icon.tag"
                                    readonly="readonly">
                                <button class="btn btn-primary" type="button" v-on:click="copy_icon">Copy text</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import data from '../../../data/fontawsomeData.json'
export default {
    data() {
        return {
            icon_bar_status: false,
            select_icon: {
                class: '',
                tag: ''
            },
            menu: [
                { name: "Icons", value: data.icons20 },
                { name: "Currency Icons", value: data.currencyicons },
                { name: "Web Icons", value: data.webicons },
                { name: "Spinner", value: data.spinner },
                { name: "Form Icons", value: data.formicons },
                { name: "Text Editor Icons", value: data.texteditoricons },
                { name: "Directional Icons", value: data.directionalicons },
                { name: "Video Icons", value: data.videoicons },
                { name: "Brand Icons", value: data.branddicons },
                { name: "Medical Icons", value: data.medicalicons },
            ]
        };
    },
    methods: {
        icon_bar(icon) {
            this.select_icon.class = 'fa fa-' + icon;
            this.select_icon.tag = '<i class="fa fa-' + icon + '"></i>';
            this.icon_bar_status = true;
        },
        close_icon_bar() {
            this.icon_bar_status = false;
        },
        copy_icon() {
            this.$refs.text.select();
            document.execCommand('copy');
            this.$toast.show('Code Copied to Clipboard', {
                theme: 'outline', position: 'bottom-right',
                closeOnSwipe: true, type: 'default',
                duration: 2000, className: 'alert-copy',
                action: {
                    icon: 'times',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
        }
    }
};
</script>